import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { HeaderComponent } from '@layout/components/header/header.component';
import { FooterComponent } from '@layout/components/footer/footer.component';
import { SidebarComponent } from '@layout/components/sidebar/sidebar.component';
import { MasterComponent } from '@layout/components/master/master.component';
import { MaterialModule } from '@shared/material.module';
import { NgHttpLoaderModule } from 'ng-http-loader';

const declarations = [
  HeaderComponent,
  FooterComponent,
  SidebarComponent,
  MasterComponent
];

@NgModule({
  imports: [SharedModule, MaterialModule, NgHttpLoaderModule],
  declarations: declarations,
  exports: declarations
})
export class LayoutModule { }
